var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-container", [
    _c(
      "div",
      [
        _c(
          "v-row",
          {
            staticClass: "mt-3 border-bottom-bold",
            attrs: {
              "no-gutters": "",
              justify: "space-between",
              "align-content": "center",
            },
          },
          [
            _c("div", { staticClass: "ml-8 mb-3" }, [
              _c(
                "div",
                {
                  staticClass:
                    "allig-show-per-page text-caption text-sm-caption text-md-caption text-lg-caption text-xl-caption",
                },
                [_vm._v(" " + _vm._s(_vm.total) + "件 ")]
              ),
            ]),
            _c("v-spacer"),
            _c(
              "div",
              {
                staticClass:
                  "text-caption display-option included-option text-sm-caption text-md-caption text-lg-caption text-xl-caption mr-8",
              },
              [
                _c(
                  "v-btn",
                  {
                    directives: [
                      {
                        name: "ripple",
                        rawName: "v-ripple",
                        value: false,
                        expression: "false",
                      },
                    ],
                    staticClass: "allig-btn-text-link-gray allig-btn-text-link",
                    attrs: { block: "", type: "button", text: "" },
                    on: {
                      click: () => {
                        _vm.showOption = !_vm.showOption
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "display-option-title" }, [
                      _vm._v(
                        " " + _vm._s(_vm.configData.TEXT_DISPLAY_OPTIONS) + " "
                      ),
                    ]),
                    _c(
                      "span",
                      [
                        _c("v-icon", { attrs: { dense: "" } }, [
                          _vm._v("mdi-chevron-down"),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "v-row",
          { staticClass: "pt-0 pb-0 mt-0" },
          [
            _c(
              "v-container",
              { staticClass: "pt-0" },
              [
                _c("display-option", {
                  attrs: {
                    isShowOption: _vm.showOption,
                    "display-option-items": _vm.displayOptionItems,
                    isVaildOnly: _vm.isVaildOnly,
                  },
                  on: {
                    "show-only-isVaild": function ($event) {
                      return _vm.$emit("show-only-isVaild", $event)
                    },
                    input: function ($event) {
                      return _vm.CheckColumn($event)
                    },
                  },
                  model: {
                    value: _vm.selectedDisplayOption,
                    callback: function ($$v) {
                      _vm.selectedDisplayOption = $$v
                    },
                    expression: "selectedDisplayOption",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.loading === false
          ? _c("v-data-table", {
              directives: [
                { name: "resizable-columns", rawName: "v-resizable-columns" },
              ],
              staticClass: "border-table scroll-table approval",
              attrs: {
                "must-sort": "",
                headers: _vm.headers,
                items: _vm.resData,
                "items-per-page": -1,
                "item-key": "request_id",
                "no-data-text": _vm.configData.TEXT_NO_DATA,
                "loading-text": _vm.configData.TEXT_LOADING_DATA,
                "hide-default-footer": "",
                "item-class": _vm.row_classes,
                "sort-by": ["begin"],
                "sort-desc": false,
              },
              on: { "current-items": _vm.currentItems },
              scopedSlots: _vm._u(
                [
                  {
                    key: `item.is_extension`,
                    fn: function ({ item }) {
                      return [
                        item.is_extension === true &&
                        item.is_extension_waiting === true
                          ? [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-primary",
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showExtDialog(
                                        item.request_id,
                                        item.requester_name,
                                        item.is_extension_waiting,
                                        item.end
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.configData.TEXT_CONFIRMATION) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: `item.request_id`,
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple",
                                value: false,
                                expression: "false",
                              },
                            ],
                            staticClass: "allig-btn-text-link go-detail",
                            attrs: { block: "", type: "button", text: "" },
                            on: {
                              click: function ($event) {
                                return _vm.goDetail(item.request_id)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.request_id) + " ")]
                        ),
                      ]
                    },
                  },
                  {
                    key: `item.begin`,
                    fn: function ({ item }) {
                      return [_vm._v(" " + _vm._s(item.begin) + " ")]
                    },
                  },
                  {
                    key: `item.end`,
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.converDateShort(item.end)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: `item.status`,
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.convertStatus(item.status)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: `item.updated`,
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.converDateShort(item.updated)) + " "
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          : _vm._e(),
        _c("v-row", {
          staticStyle: { height: "20px" },
          attrs: { "no-gutters": "" },
        }),
        _c("v-spacer"),
        _vm.loadMore
          ? _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-secondary margin-button-load-more",
                    attrs: { outlined: "" },
                    on: {
                      click: function ($event) {
                        return _vm.countPage()
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.configData.TEXT_BUTTON_OTHERS) + " "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.openExtensions === false
          ? _c(
              "v-dialog",
              {
                attrs: { persistent: "", "max-width": "600" },
                model: {
                  value: _vm.confirmDialogExtention,
                  callback: function ($$v) {
                    _vm.confirmDialogExtention = $$v
                  },
                  expression: "confirmDialogExtention",
                },
              },
              [
                _vm.resExtData.status === "waiting"
                  ? _c(
                      "v-card",
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass: "modal-title",
                            attrs: { color: "black" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.configData.TEXT_EXTENSION_CONFIRMATION
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "mt-5" },
                          [
                            _vm.endTime < _vm.currentTime
                              ? _c("div", [
                                  _c("p", { staticClass: "error-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.configData
                                          .TEXT_ERROR_WORK_PERIOD_EXPIRED_APPROVAL_TOP
                                      )
                                    ),
                                  ]),
                                  _c("p", { staticClass: "error-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.configData
                                          .TEXT_ERROR_WORK_PERIOD_EXPIRED_APPROVAL_BOTTOM
                                      )
                                    ),
                                  ]),
                                ])
                              : _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.configData
                                          .TEXT_APPROVE_EXTENSION_REQUEST
                                      )
                                    ),
                                  ]),
                                ]),
                            _c("v-row", {
                              staticStyle: { height: "10px" },
                              attrs: { "no-gutters": "" },
                            }),
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "10px" } },
                              [_vm._v(_vm._s(_vm.requesterName))]
                            ),
                            _c("v-row", {
                              staticStyle: { height: "20px" },
                              attrs: { "no-gutters": "" },
                            }),
                            _c("v-text-field", {
                              staticClass: "input-time",
                              attrs: {
                                color: "green",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                autocomplete: "off",
                                disabled: "",
                              },
                              model: {
                                value: _vm.extPeriodTime,
                                callback: function ($$v) {
                                  _vm.extPeriodTime = $$v
                                },
                                expression: "extPeriodTime",
                              },
                            }),
                            _c("v-row", {
                              staticStyle: { height: "20px" },
                              attrs: { "no-gutters": "" },
                            }),
                            _c("v-textarea", {
                              staticClass: "input-time",
                              attrs: {
                                color: "green",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                autocomplete: "off",
                                label: _vm.configData.TEXT_LABEL_NO_COMMENT,
                                solo: "",
                                disabled: "",
                              },
                              model: {
                                value: _vm.description,
                                callback: function ($$v) {
                                  _vm.description = $$v
                                },
                                expression: "description",
                              },
                            }),
                            _c("v-row", {
                              staticStyle: { height: "20px" },
                              attrs: { "no-gutters": "" },
                            }),
                            _c("v-textarea", {
                              staticClass: "input-time",
                              attrs: {
                                color: "green",
                                outlined: "",
                                dense: "",
                                "hide-details": "auto",
                                autocomplete: "off",
                                label:
                                  _vm.configData.TEXT_LABEL_COMMENT_APPROVER,
                                solo: "",
                              },
                              model: {
                                value: _vm.comment,
                                callback: function ($$v) {
                                  _vm.comment = $$v
                                },
                                expression: "comment",
                              },
                            }),
                            _c("v-spacer"),
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-2",
                                attrs: { justify: "end" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-secondary",
                                    attrs: { outlined: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.confirmDialogExtention = false
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.configData.TEXT_CLOSE_UP))]
                                ),
                                _vm.displayPriviledge === "2"
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "mr-2 btn-primary",
                                        attrs: {
                                          disabled:
                                            _vm.endTime < _vm.currentTime,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionApproval(
                                              "approved"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.configData
                                                .TEXT_EXTENSION_APPROVAL
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.displayPriviledge === "2"
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "btn-primary",
                                        attrs: { outlined: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionApproval(
                                              "declined"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.configData
                                                .TEXT_EXTENSION_DENIAL
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "v-card",
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass: "modal-title",
                            attrs: { color: "black" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.configData.TEXT_EXTENSION_CONFIRMATION
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-card-text", { staticClass: "mt-5" }, [
                          _c("div", [
                            _c("p", { staticClass: "error-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.configData
                                    .TEXT_ERROR_NO_UNAPPROVED_EXTENSION_APPLICATIONS
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-2",
                                attrs: { justify: "end" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn-secondary",
                                    attrs: { outlined: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.confirmDialogExtention = false
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.configData.TEXT_CLOSE_UP))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "v-dialog",
          {
            attrs: { persistent: "", "max-width": "600" },
            model: {
              value: _vm.confirmDialogExtentionComment,
              callback: function ($$v) {
                _vm.confirmDialogExtentionComment = $$v
              },
              expression: "confirmDialogExtentionComment",
            },
          },
          [
            _c(
              "v-card",
              [
                _c(
                  "v-card-title",
                  { staticClass: "modal-title", attrs: { color: "black" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.configData.TEXT_EXTENSION_CONFIRMATION) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "v-card-text",
                  { staticClass: "mt-5" },
                  [
                    _c("v-row", {
                      staticStyle: { height: "20px" },
                      attrs: { "no-gutters": "" },
                    }),
                    _c("v-textarea", {
                      staticClass: "input-time",
                      attrs: {
                        color: "green",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        autocomplete: "off",
                        label: _vm.configData.TEXT_LABEL_COMMENT_APPROVER,
                        solo: "",
                      },
                      model: {
                        value: _vm.description,
                        callback: function ($$v) {
                          _vm.description = $$v
                        },
                        expression: "description",
                      },
                    }),
                    _c("v-spacer"),
                  ],
                  1
                ),
                _c(
                  "v-card-actions",
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-2", attrs: { justify: "end" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-secondary",
                            attrs: { outlined: "" },
                            on: {
                              click: function ($event) {
                                return _vm.returnExtDialog()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.configData.TEXT_RETURN))]
                        ),
                        _vm.displayPriviledge === "2"
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "btn-primary",
                                attrs: { outlined: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.actionApproval("")
                                  },
                                },
                              },
                              [_vm._v("OK")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }